/**
 * @implements {IChilduppNotification}
 */
export class NoneChilduppNotification {
    constructor() {}

    /**
     * @inheritDoc
     */
    name() {
        return "none";
    }

    /**
     * @inheritDoc
     */
    requestPermission() {
        return new Promise((resolve) => {
            resolve();
        });
    }

    /**
     * @inheritDoc
     */
    hasPermission() {
        return false;
    }

    /**
     * @inheritDoc
     */
    getToken() {
        return undefined;
    }

    /**
     * @inheritDoc
     */
    onTokenRefresh(cb) {
        return () => {};
    }

    /**
     * @inheritDoc
     */
    onNotification(cb) {
        return () => {};
    }
}



// WEBPACK FOOTER //
// ./src/shared/childupp-notifications/none-childupp-notification.js